
import { defineComponent, ref } from 'vue';

import IconPng1 from '@/assets/image/home/icon-long-1-1.png';
import IconPng2 from '@/assets/image/home/icon-long-1-2.png';
import IconPng3 from '@/assets/image/home/icon-long-1-3.png';

import { EnvironmentOutlined } from '@ant-design/icons-vue';

import { useRouter, useRoute, RouteLocationNormalized } from 'vue-router';

import { MenuInfo } from 'ant-design-vue/lib/menu/src/interface';

import FeatureCard from './FeatureCard.vue';

export default defineComponent({
  name: 'FeatureArea',
  components: {
    EnvironmentOutlined,
    FeatureCard,
  },
  setup() {
    const selectedKeys = ref<string[]>([]);
    const route = useRoute();
    setKeys(route);

    const router = useRouter();
    router.afterEach(to => {
      setKeys(to);
    });

    const clickMenuItem = (e: MenuInfo) => {
      const key2 = e.key as string;
      selectedKeys.value = [key2];
      router.push(key2);
    };
    function setKeys(to: RouteLocationNormalized) {
      const path = to.path;
      // openKeys.value.push(path.slice(0, path.indexOf('/', 1)));
      selectedKeys.value = [path];
    }
    const linkItem = (name: string) => {
      let routeData = router.resolve({ name });
      window.open(routeData.href, '_blank');
    };

    return {
      IconPng1,
      IconPng2,
      IconPng3,
      selectedKeys,
      clickMenuItem,
      linkItem,
    };
  },
});
